import React, {useState} from 'react'
import styled from 'styled-components'
import Input from '../Input/Input'
import {Layer} from 'grommet/components/Layer'

const StyledContent = styled.div`
  width: 100%;
  border-radius: 6px;
  box-sizing: border-box;
  overflow-y: auto;
  max-height: 70vh;
  padding: 10px;
  background: #ffffff;
  &::-webkit-scrollbar {
    width: 5px;
    margin-right: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #757575;
    border-radius: 15px;
  }
`

const StyledOption = styled.div`
  width: 100%;
  height: 72px;
  min-width: 300px;
  border-radius: 6px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.5px;
  cursor: pointer;
  box-sizing: border-box;
  user-select: none;
  color: ${props => (props.selected ? '#3395fe' : '#000000')};
  box-shadow: ${props =>
    props.selected ? '0 1px 6px 0 rgba(51, 149, 254, 0.38)' : 'none'};
`

const OptionContainer = styled.div`
  padding: 8px;
  box-sizing: border-box;
  width: 100%;
`

const SelectPopup = props => {
  const {onSelect, options, value, valueField, displayField} = props

  const [showPopup, setShowPopup] = useState(false)

  const onSelectItem = ({option}) => {
    setShowPopup(false)
    onSelect(option)
  }

  const onClick = () => {
    setShowPopup(!!options.length)
  }

  const onClose = () => {
    setShowPopup(false)
  }

  let [selectedItem] = options.filter(option => option[valueField] === value)
  let displayValue = selectedItem ? selectedItem[displayField] : ''

  return (
    <>
      <div style={{paddingTop: 8, userSelect: 'none'}}>
        <Input value={displayValue} readOnly onClick={onClick} />
      </div>

      {showPopup && (
        <Layer position="center" modal onClickOutside={onClose} onEsc={onClose}>
          <StyledContent>
            {options.map(option => (
              <OptionContainer key={option[valueField] || option[displayField]}>
                <StyledOption
                  onClick={() => onSelectItem({option})}
                  selected={value === option[valueField]}
                >
                  {option[displayField]}
                </StyledOption>
              </OptionContainer>
            ))}
          </StyledContent>
        </Layer>
      )}
    </>
  )
}

export default SelectPopup
